import { Reducer } from 'redux'

import {
  CLEAR_CURRENT_PROFILE_SHARING,
  FetchMyProfileSharingAvailableTypes,
} from 'actions/profile/profileDataAction'
import {
  FETCH_CURRENT_AUTHORIZED_PROFILE_SHARING_AVAILABLE,
  fetchCurrentAuthorizedProfileSharingAvailableAction,
} from 'actions/sharingContent/fetchCurrentAuthorizedProfileSharingAvailableAction'
import {
  FETCH_CURRENT_AUTHORIZED_PROFILE_SHARING_INFO,
  fetchCurrentAuthorizedProfileSharingInfoAction,
} from 'actions/sharingContent/fetchCurrentAuthorizedProfileSharingInfoAction'
import {
  FetchSharingUrlListAction,
  FETCH_SHARING_URL_LIST,
} from 'actions/sharingContent/fetchSharingUrlListAction'
import { ShareHitMethodAction } from 'actions/sharingContent/shareHitMethodStatisticsAction'
import {
  RESTORE_INITIAL_STATE,
  RestoreInitialStateAction,
} from 'actions/system/restoreInitialStateAction'
import { SharingMethod } from 'api/sharingContentApi'
import { DeprecatedApi6Error } from 'api/types'
import { initialStateReducer } from 'reducers/default/initialStateReducer'
import { defaultPromiseReducer } from 'reducers/defaultPromiseReducer'
import {
  mapSharingItems,
  SharingMethodSocialMap,
} from 'reducers/sharing/sharing.function'

export interface SharingContentState {
  sharingMethods: SharingMethod[]
  sharingContentLoaded: boolean
  isCurrentProfileSharingAvailable: boolean
  isCurrentProfileSharingAvailableLoaded: boolean
  currentProfileSharingInfoImage: string | null
  currentProfileSharingInfoError: DeprecatedApi6Error | null
  contentId: number
  profileId: number
}

export const sharingContentReducer: Reducer<
  SharingContentState,
  | FetchSharingUrlListAction
  | ReturnType<typeof fetchCurrentAuthorizedProfileSharingInfoAction>
  | ReturnType<typeof fetchCurrentAuthorizedProfileSharingAvailableAction>
  | ShareHitMethodAction
  | FetchMyProfileSharingAvailableTypes
  | RestoreInitialStateAction
> = (
  state = {
    sharingMethods: [],
    contentId: 0,
    profileId: 0,
    sharingContentLoaded: false,
    isCurrentProfileSharingAvailableLoaded: false,
    isCurrentProfileSharingAvailable: false,
    currentProfileSharingInfoImage: null,
    currentProfileSharingInfoError: null,
  },
  action
): SharingContentState => {
  switch (action.type) {
    case FETCH_SHARING_URL_LIST:
      return defaultPromiseReducer(
        state,
        action,
        () => ({
          sharingContentLoaded: false,
        }),
        (result) => {
          const mappedData = mapSharingItems(action.result!.urls).filter(
            (item) => SharingMethodSocialMap[item.sharingMethod]
          )
          return {
            contentId: result.contentIdentity.contentId,
            profileId: result.contentIdentity.ownerId,
            sharingMethods: mappedData,
            sharingContentLoaded: true,
          }
        },
        () => ({
          sharingContentLoaded: false,
        })
      )

    case FETCH_CURRENT_AUTHORIZED_PROFILE_SHARING_AVAILABLE: {
      return defaultPromiseReducer(
        state,
        action,
        undefined,
        ({ thisIsMe }) => ({
          isCurrentProfileSharingAvailable: thisIsMe,
          isCurrentProfileSharingAvailableLoaded: true,
        })
      )
    }

    case FETCH_CURRENT_AUTHORIZED_PROFILE_SHARING_INFO: {
      return defaultPromiseReducer(
        state,
        action,
        undefined,
        ({ image, urls }) => {
          const mappedData = mapSharingItems(urls).filter(
            (item) => SharingMethodSocialMap[item.sharingMethod]
          )
          return {
            sharingMethods: mappedData,
            currentProfileSharingInfoImage: image,
          }
        },
        (result) => ({
          currentProfileSharingInfoError: result as any,
        })
      )
    }

    case CLEAR_CURRENT_PROFILE_SHARING: {
      return {
        ...state,
        currentProfileSharingInfoImage: null,
        sharingMethods: [],
        currentProfileSharingInfoError: null,
        contentId: 0,
        profileId: 0,
      }
    }

    case RESTORE_INITIAL_STATE:
      return initialStateReducer(state, action, 'sharingContent')

    default:
      return state
  }
}
